import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, catchError, throwError, of, EMPTY } from "rxjs";
import { AuthService } from "../services/auth.service";
import { environment } from "../../environments/environment";


@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url === "https://gp.0x6e.com/user-login" || req.url.includes(environment.cdnUrl)) {
      return next.handle(req); // skip auth logic
    }

    let token: string | null;
    try {
      //get token from LS to prevent circular dependency error with authService's getUserinfo at initialization
      token = localStorage.getItem('sessionToken');
    } catch (error) {
      console.warn(`Error accessing localStorage in interceptor while ${req.body?.method}:`, error);
      //check token in the app: authService - if logged in, the token will be in authService
      const authService = inject(AuthService);
      token = authService.tokenSignal();
    }

    let request = req;

    if (token && !req.headers.has('Authorization')) {
      request = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      })

    }

    return next.handle(request)
      .pipe(
        catchError(err => throwError(() => err)));

  }

}
